// //For medlemsbarn we have uploaded json in zip component.
// $scope.getUplodedJSONUrl = function(val) {
//     var appBaseUrl = '';
//     if(vm.config.isLocalhost != undefined && vm.config.isLocalhost.toLowerCase() === 'true') {
//         appBaseUrl = vm.config.appBaseUrl;
//     }
//     var url = appBaseUrl + vm.config.versionPath + '/assets/apps/'+val+'.json';
//     return url;

// }
import fetchJsonp from 'fetch-jsonp';
export function readJSONfromUrl(url) {}

/**
 * Helper functions for field toggle functionality
 */
export function extractToggleState(key) {
    const keySplit = key.split(':');
    return keySplit[keySplit.length - 1];
}
export function extractToggleGroup(key) {
    const keySplit = key.split(',');
    return keySplit[0];
}

export function normalizeOptions(options = []) {
    return options.map(option => {
        return { description: option.kortkod, value: option.klarText };
    });
}
export async function fetchJSONP(url, postdata) {
    return fetchJsonp(url, {
        jsonpCallbackFunction: 'callback'
    })
        .then(function(response) {
            return response.json();
        })
        .then(function(json) {
            return json;
        })
        .catch(function(ex) {
            console.error('Parsing of callback failed', ex);
        });
}

export function generateDefaultToggleMapping(fields) {
    return fields.reduce((acc, item) => {
        // only applies to fields that are of typ DropDown and have a catJSONMap structure
        if (item.inputControl === 'DropDown' && item.catJSONMap && item.catJSONMap[0].key !== '') {
            const inputGroup = extractToggleGroup(item.catJSONMap[0].key);
            let togglem = item.catJSONMap?.reduce(
                (acc, option) => {
                    if (acc[inputGroup]) {
                        acc[inputGroup][option.description] = extractToggleState(option.key);
                    } else {
                        acc[inputGroup] = {};
                    }
                    return acc;
                },

                {
                    [inputGroup]: { fieldName: item.name }
                }
            );

            acc = togglem;
            return acc;
        }
        return acc;
    }, {});
}

export function generateSpecialToggleMapping(fields, isMoped = null) {
    /**
     * this bannertype check is made because we need to generate special
     * togglemappings for certain product banners ex Moped which uses the Address type for a toggle between 2 non address fields
     */
    if (isMoped) {
        return { mopedRegOrYear: { J: 'regnr', N: 'arsmodell', fieldName: 'regnrFlg' } };
    } else {
        return generateDefaultToggleMapping(fields);
    }
}

export function searchToObject(search) {
    return search
        .substring(1)
        .split('&')
        .reduce(function(result, value) {
            var parts = value.split('=');
            if (parts[0]) result[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
            return result;
        }, {});
}
function isMobileDevice() {
    const USERAGENT_REGEXP = /FxiOS|(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/;
    const { userAgent } = window.navigator;
    return USERAGENT_REGEXP.test(userAgent);
}
function isDesktop() {
    // TODO:
    // Old inplementation used Modernizr.touchevents and fdr.$win.width() > 1024 to  determine if client is a Desktop
    // but its too big, so we should implement a smaller package
    return !isMobileDevice() && window.innerWidth > 1024;
}

/**
 * This whole function is only necessary because of the need to have specific target based on things like, if its Desktop etc.
 * in my opinion we should not have this, when we can remove the old WAS flow applications we can get rid of this and standardize
 */
export function getFormTarget({ windowType, encryptJSParam }) {
    const type = windowType?.toLowerCase();

    if (encryptJSParam) {
        switch (type) {
            case 'modalwindow':
                return '_self';
            case 'samewindow':
                return '_self';
            default:
                //if browser is firefox in iOS - iPhone, iPad, iPod then open in a same window always
                if (isMobileDevice()) {
                    return '_self';
                } else {
                    return '_blank';
                }
        }
    } else {
        // this is a legacy flow
        switch (type) {
            case 'modalwindow':
                if (isDesktop()) {
                    return 'product-iframe';
                } else if (isMobileDevice()) {
                    return '_self';
                } else {
                    return '_blank';
                }
            case 'samewindow':
                return '_self';
            case 'newwindow':
                if (isMobileDevice()) {
                    return '_blank';
                }
                break;
            default:
                return '_blank';
        }
    }
}

export function readConfiguration(rootId) {
    const rootElement = document.querySelector(`[data-folksam-app-id="${rootId}"]`);
    const translations = rootElement.querySelector(`.app-translations`)?.value;
    const configuration = rootElement.querySelector(`.app-config`)?.value;
    const componentData = rootElement.querySelector(`.app-componentdata`)?.value;
    const commonData = rootElement.querySelector(`.app-commondata`)?.value;

    const parsedComponentData = componentData ? JSON.parse(componentData) : null;

    return {
        translations: translations ? JSON.parse(translations) : null,
        configuration: configuration ? JSON.parse(configuration) : null,
        componentData: parsedComponentData
            ? {
                  ...parsedComponentData,
                  categoryServiceUrl: parsedComponentData?.categoryServiceUrl?.key,
                  categoryServiceUrlFUP: parsedComponentData?.categoryServiceUrlFUP?.key,
                  productflowUrl: parsedComponentData?.productflowUrl?.key,
                  windowType: parsedComponentData?.windowTypeSerialized?.key
              }
            : null,
        commonData: commonData ? JSON.parse(commonData) : null
    };
}

export function calculateNumberOfVisibleFields(numberOfFields) {
    switch (numberOfFields) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 2;

        default:
            return 1;
    }
}
